import React, { useEffect, useState } from 'react';
import 'antd/dist/reset.css'; // Include Ant Design styles
import '../../Styles/Linkages.css';  
import ToDoList from './ICASE Components/ToDoList';
import FooterComponent from '../../Layout/Footer';
import ConferenceHighlights from './ICASE Components/ConferenceHighlights';
import ICASELegacy from './ICASE Components/ICASELegacy';
import ICASEVideos from './ICASE Components/ICASEVideos';
import ICASESocialFeed from './ICASE Components/ICASESocialFeed';
import ICASEGallery from './ICASE Components/ICASEGallery';
import Header from '../../Layout/Header';
import icaseBanner from '../../Assets/Linkages/InternationalConferences/ICASE-Page-Banner.jpg';
import icaseIntroduction from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction.jpg';
import IcaseLogo from '../../Assets/ICASE/icase-logo.jpg';
import icaseIntroduction02 from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction-02.jpg';
import icaseIntroduction03 from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction-03.jpg';
import icaseIntroduction04 from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction-04.jpg';
import icaseIntroduction05 from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction-05.jpg';
import icaseIntroduction06 from '../../Assets/Linkages/InternationalConferences/ICASE-Introduction-06.jpg';

const introductionImages = [icaseIntroduction, icaseIntroduction02, icaseIntroduction03, icaseIntroduction04, icaseIntroduction05, icaseIntroduction06];

const ICase = () => {
  const [introductionSlide, setIntroductionSlide] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIntroductionSlide((current) => (current + 1) % introductionImages.length);
    }, 3000);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <>
      <Header />
      <main className="icase-page">
      <section className="icase-page-banner" aria-label="International Conference on Aerospace Science and Engineering">
        <img src={icaseBanner} alt="International Conference on Aerospace Science and Engineering" />
      </section>

      <section className="icase-introduction" aria-labelledby="icase-introduction-title">
        <div className="icase-introduction-inner">
          <div className="icase-introduction-layout">
            <div className="icase-introduction-copy">
              <p className="section-eyebrow">ABOUT THE CONFERENCE</p>
              <h1 id="icase-introduction-title">Introduction</h1>
              <div className="icase-title-line" aria-hidden="true" />
              <p className="icase-introduction-text">
                International Conference on Aerospace Science &amp; Engineering (ICASE) is a regular
                biennial event providing an international forum where scientists, researchers,
                engineers, academicians, industry professionals, entrepreneurs, and students from all
                over the world have the opportunity to interact and discuss the latest themes and trends
                related to aerospace science and engineering. It provides a platform to share
                experiences, foster collaborations across industry and academia, and evaluate emerging
                technologies and developments across the globe in the fields of space science,
                technology, and applications. ICASE facilitates the establishment of dialogues leading
                to long-lasting technical cooperation among scientists and engineers from developing
                and developed countries.
              </p>
            </div>
            <div className="icase-introduction-gallery">
              <figure className="icase-introduction-image">
                <img
                  src={IcaseLogo}
            
                />
              </figure>
     
            </div>
          </div>
        </div>
      </section>
      <ICASELegacy />
      <div className="icase-page-content">
{/* <OnlineSessions/> */}
<ToDoList/>
<ConferenceHighlights/>
      </div>
      <ICASEVideos />

      <ICASESocialFeed />
      <ICASEGallery />

      </main>
      <FooterComponent/>
    </>
  );
};

export default ICase;
